// The rack-size choices, React-free. Split out of rackLayout.ts (which imports
// the React rack visualisation for calculateRackLayout) so the MCP Lambda's
// buildOptions (CONF-112, src/configEngine/options.ts) can offer the same list
// without bundling React. rackLayout.ts re-exports it, so UI importers are unchanged.

/** §1.6 rule 11: the real sizes. 0 packs as 42 inside calculateRackLayout.
 *
 *  Five sizes, not four. The plan and the vault spec both list 0/25/42/48; the SHIPPING
 *  classic dropdown (RealisticRackVisualization.jsx:442) offers 0/25/42/48/52 and writes
 *  the choice straight to `config.rackSize` (SystemAttributesCard.jsx:266) — the same
 *  field rackSlidePPTGenerator.js:168 reads. Spec rule 11: where the prototype and the
 *  code disagree, the code wins. Dropping 52 here made the Picker's native mirror fall
 *  back to '0' and the Radix trigger render blank for a saved 52U quote, so a rep saw
 *  "No Rack" over a correctly-drawn 52U rack and one touch of the control silently
 *  rewrote rackSize and changed the exported deck. */
export const RACK_SIZE_OPTIONS = [
  { value: '0', label: 'No Rack' },
  { value: '25', label: '25U' },
  { value: '42', label: '42U' },
  { value: '48', label: '48U' },
  { value: '52', label: '52U' },
];
